import React, {useEffect, useState} from "react";
import styled, { withTheme } from "styled-components";
// import {motion} from 'framer-motion';
// Imported Components
import ExchangeTopGames from "./exchangepage-topgames/index";
import HomeExchange, { AppWrapper } from "../../home-exchange/index";
// import { Outlet } from "react-router-dom";
import { withAppContext } from "src/store/initAppContext";
import config from "src/config/config";
import { theme } from "styled-tools";
import { useLocation, useParams } from "react-router-dom";
import { CRMPageVisit } from "src/util/crmUtil";
import { getDamain } from "src/util/commonfun";
import { MetaProps, SEOFooterCommon, SEOMetaCommon } from "src/components/SEOMetaCommon";
import { sportsGamesSEOData } from "src/config/seo_api";

const ExchangePage = (props) => {
  const {
    app: { brandId },
    theme,
  } = props;

  const { id } = useParams();
  let domainURL = getDamain(brandId);
  const { config: { showAPISEOData } } = theme;

  const [seoObjects, setseoObjects] = useState({} as MetaProps);
  const _location = useLocation();
  const pathName = _location.pathname;
  const getSeoData = sportsGamesSEOData();


  useEffect(()=> {
    //for CRM
    CRMPageVisit();
  },[])

   //for SEO
    useEffect(() => {
        if (showAPISEOData) {
            // const getSeoData = sportsGamesSEOData();
            // const pathName = _location.pathname;
            getSeoData.then(resp => {
                const { objects } = resp;
                
                const seoData = objects.find((obj: any) => {
                    const { metadata = {} } = obj;
                    if (metadata.pathname && metadata.pathname === pathName) {
                        return obj;
                    }

                }) || {};

                const { metadata = {} } = seoData;
                setseoObjects(metadata);

            }).catch(error => console.log(`[${pathName}]:Error in SEO API`))

        }
    }, [pathName]);

  return (
    <ExchangeWrapper>
      {showAPISEOData && (<SEOMetaCommon metaData={seoObjects} />)}

      <ExchangeTopGames />
      <HomeExchange />
      {/* <Outlet/> */}
     {showAPISEOData && <SEOFooterCommon footer_title={seoObjects['seo_footer_title_(h1)']} footer_content={seoObjects['seo_footer_content']} />}
    </ExchangeWrapper>
    // </motion.div>
     
  );
};

export default withTheme(withAppContext(ExchangePage));

/*! styled-components */
const ExchangeWrapper = styled.div`
  width: 100%;
  height: auto;
  background-image: url(${config.imageV3Host}/static/cashsite/${theme("image.homeExchangeBgImage")});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top right;
  background-attachment: fixed;

  ${AppWrapper} {
    min-height: 100vh;
  }

`;
